import { render } from "./MemberOverlayProfileCard.vue?vue&type=template&id=28a742b6"
import script from "./MemberOverlayProfileCard.vue?vue&type=script&lang=js"
export * from "./MemberOverlayProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__